var _ellipse, _rect, _g, _rect2, _path, _rect3, _path2, _rect4, _rect5, _rect6, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoResponseEmailCampaign(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 140,
    viewBox: "0 0 150 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 75,
    cy: 70,
    rx: 74.5,
    ry: 70,
    fill: "#F2FBFD"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 45.5464,
    y: 83.8372,
    width: 59.7733,
    height: 19.5349,
    rx: 4,
    fill: "#CAF0F8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 57.7412,
    y: 28.9884,
    width: 34.9506,
    height: 20.9957,
    rx: 3.5,
    fill: "white",
    stroke: "#ADE8F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9668 28.9884H91.4658C92.1427 28.9884 92.6913 29.5371 92.6914 30.214C92.6914 30.6061 92.5046 30.9712 92.1943 31.2003L92.0537 31.2901L76.8945 39.5714C75.9142 40.1069 74.7416 40.1396 73.7373 39.671L73.5381 39.5714L58.3789 31.2901C57.9856 31.0752 57.7412 30.6622 57.7412 30.214C57.7413 29.5371 58.29 28.9885 58.9668 28.9884Z",
    fill: "#CAF0F8",
    stroke: "#ADE8F4"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 51.6772,
    y: 34.686,
    width: 47.0785,
    height: 28.4159,
    rx: 3.5,
    fill: "white",
    stroke: "#ADE8F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.4849 34.686H96.9478C97.9461 34.686 98.7552 35.4953 98.7554 36.4937C98.7554 37.1137 98.4384 37.6877 97.9204 38.0181L97.8149 38.0806L76.894 49.5083C75.9136 50.0438 74.7412 50.0776 73.7368 49.6089L73.5386 49.5083L52.6187 38.0806C52.0384 37.7636 51.6772 37.1548 51.6772 36.4937C51.6774 35.4954 52.4866 34.6862 53.4849 34.686Z",
    fill: "#CAF0F8",
    stroke: "#ADE8F4"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 47.7793,
    y: 43.6395,
    width: 54.875,
    height: 33.1861,
    rx: 3.5,
    fill: "white",
    stroke: "#ADE8F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9619 43.6395H100.472C101.677 43.6395 102.654 44.617 102.654 45.8221C102.654 46.5702 102.271 47.2622 101.646 47.661L101.519 47.7372L76.8945 61.1884C75.9143 61.7237 74.7416 61.7574 73.7373 61.2889L73.5391 61.1884L48.915 47.7372C48.2148 47.3547 47.7795 46.62 47.7793 45.8221C47.7793 44.617 48.7567 43.6395 49.9619 43.6395Z",
    fill: "#CAF0F8",
    stroke: "#ADE8F4"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 48.1455,
    y: 50.4651,
    width: 54.5756,
    height: 8.13954,
    fill: "#48CAE4"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 51.6104,
    y: 38.2558,
    width: 47.6453,
    height: 5.69767,
    fill: "#48CAE4"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 38.25,
    y: 54.2209,
    width: 73.5,
    height: 44.5814,
    rx: 3.5,
    fill: "white",
    stroke: "#0096C7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3262 54.2209H108.674C110.373 54.221 111.75 55.5982 111.75 57.2971C111.75 58.3518 111.21 59.3276 110.329 59.8899L110.148 59.9973L76.6777 78.2815C75.6974 78.8169 74.5248 78.8498 73.5205 78.3811L73.3223 78.2815L39.8516 59.9973C38.8642 59.458 38.25 58.4222 38.25 57.2971C38.25 55.5982 39.6273 54.221 41.3262 54.2209Z",
    fill: "#ADE8F4",
    stroke: "#0096C7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoResponseEmailCampaign);
export default __webpack_public_path__ + "static/media/NoResponseEmailCampaign.944be934d875e6b967ec122d6ebe289e.svg";
export { ForwardRef as ReactComponent };